export default () => ({
    configsToEdit: "",
    taxRateForDoctors: "",
    taxRateForHospital: "",
    currencyId: null,
    accounting: {
        accountsReceivablePersonals: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        clinicServiceIncome: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        discount: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        cash: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        poses: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        commercialPaymentsAccountsDoctors: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        organizationOfTaxDoctorsTax: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        organizationOfTaxHospitalsTax: {
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        costOfDoctorsServices:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        bankCards:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        receivedCash:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: "",
            detailAccountId: ""
        },
        returnFromServicesRendered:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: ""
        },
        excessReceived:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: ""
        },
        commercialPaymentsAccountsPatients:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: ""
        },
        donationClinic:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: ""
        },
        IPD:{
            accountGroupId: "",
            totalAccountId: "",
            subsidiaryAccountId: ""
        }
    }
});
